<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "ArtigosModule"
    }
</script>

<style scoped>

</style>
